import { DELETESESSION_SUCCESS, DELETESESSION_FAIL } from '../actionTypes';

const initialState = {
    user: null,
};

const deleteSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETESESSION_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETESESSION_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default deleteSessionReducer;
